import Card from 'react-bootstrap/Card';
import InputGroup from 'react-bootstrap/InputGroup';
import React, {useEffect, useRef, useState, useCallback} from "react";
import LoaderService from "../../RetroAssets.System/LoaderService";
import apiClient from "../../services/axios";
import {alert, confirm} from "devextreme/ui/dialog";
import {Template, TextBox, TextArea} from "devextreme-react";
import cl from "../../RetroAssets.System/Utilities";
import {ContextMenuTemplate, MoreOptionsButton} from "../../RetroAssets.System/MoreOptionsButton";
import Button from "react-bootstrap/Button";
import ManageBankLoanDetails from "../Popups/ManageBankLoanDetails";
import {DataGrid} from "devextreme-react/data-grid";
import {onExcelExporting} from "../../RetroAssets.System/CellRenderImage";
import store from "store";
import {useNavigate} from "react-router-dom";

function Loans() {
    const navigate = useNavigate();
    const spanString = 'BankLoans'
    const searchBoxRef = useRef(null)
    const gridInstance = useRef()
    const [gridData, setGridData] = useState([])
    const [gridColumns, setGridColumns] = useState([])
    const [gridCustomization, setGridCustomization] = useState([])
    const [manageBankLoanDetails, setManageBankLoanDetails] = useState({
        show: false,
        externalId: '',
        readOnly: false,
    })
    const [isDoubleClick, setIsDoubleClick] = useState(false)
    const [height, setHeight] = useState(10)

    useEffect(() => {
        getData(false)
    }, []);

    function getData(showSuccessToast) {
        LoaderService.setData(true)
        apiClient
            .get('/BankLoan/GetAllBankLoans')
            .then(response => {
                try {
                    setHeight(cl.setDataGridHeight() - 23)
                    let data = JSON.parse(response.data)
                    setGridData(data[0]["Data"])
                    let settings = data[1]["Settings"]

                    let cols = settings[0][spanString][0]["Columns"]
                    let index = cols.findIndex(x => x.dataField === "Remarks")
                    if (index > -1) {
                        cols[index]["editCellTemplate"] = "remarksTemplate";
                    }
                    setGridColumns(cols)
                    setGridCustomization(settings[0][spanString][3]["GridCustomization"][0])
                    if (showSuccessToast)
                        cl.showSuccessToast()
                    LoaderService.setData(false)
                } catch (e) {
                    LoaderService.setData(false)
                    return alert(response.data, 'Error!')
                }
            })
            .catch(err => {
                LoaderService.setData(false)
                console.log(err)
                return alert(err, 'Error!')
            })
    }

    //#region Database Update

    function markAsCompleted(externalId) {
        LoaderService.setData(true)
        let params = new URLSearchParams({
            externalId: externalId
        })
        apiClient
            .get('/BankLoan/MarkBankLoanAsCompleted?' + params)
            .then(response => {
                try {
                    LoaderService.setData(false)
                } catch (e) {
                    LoaderService.setData(false)
                    return alert(response.data, 'Error!')
                }
            })
            .catch(err => {
                LoaderService.setData(false)
                console.log(err)
                return alert(err, 'Error!')
            })
    }

    //#endregion

    const searchByText = e => {
        gridInstance.current?.instance().searchByText(e.value ? e.value : null)
    }

    const clearFilter = () => {
        gridInstance.current?.instance().clearFilter()
        searchBoxRef.current?.instance().searchByText('')
        searchBoxRef.current?.instance().option('value', null)
    }

    const cellPrepared = e => {
        cl.setHeaderTooltip(e)
        cl.setColumnColorsFromVM(e)
    }

    const addNewBankLoan = e => {
        setManageBankLoanDetails({
            ...manageBankLoanDetails,
            show: true,
            externalId: '',
            readOnly: false,
        })
    }

    const contextMenuPreparing = e => {
        if (!e.row) return;
        if (e.row.rowType !== 'data') return
        e.items = []
        e.component.selectRows(e.row.key)

        e.items.push({
            text: "View Details",
            onClick: () => {
                setManageBankLoanDetails({
                    ...manageBankLoanDetails,
                    show: true,
                    externalId: e.row.key,
                    readOnly: true,
                })
            }
        })

        e.items.push({
            text: "Edit Details",
            onClick: () => {
                setManageBankLoanDetails({
                    ...manageBankLoanDetails,
                    show: true,
                    externalId: e.row.key,
                    readOnly: false,
                })
            }
        })

        e.items.push({
            beginGroup: true,
            text: "Manage Transactions",
            onClick: () => {
                settingsForBankLoanTransactions(e.row.data)
            }
        })

        e.items.push({
            beginGroup: true,
            text: e.row.data["Completed"] ? "Mark Completed" : "Unmark Completed",
            onClick: () => {
                confirm("Are you sure you wish to mark the bank loan as completed?<br/>Once completed you will no longer be able to add new transactions.", "Warning!").then(resp => {
                    if (resp)
                        markAsCompleted(e.row.key)
                })
            }
        })
    }

    const RemarksColumn = (props) => {
        const onValueChanged = useCallback(
            (e) => {
                if (!e.event) return
                LoaderService.setData(true)
                let params = new URLSearchParams({
                    externalId: props.data.externalId,
                    remark: e.value
                })
                apiClient
                    .get('/BankLoan/UpdateBankLoanRemark?' + params)
                    .then(response => {
                        try {
                            LoaderService.setData(false)
                            let resp = JSON.parse(response.data)
                            if (resp[0].response) {
                                cl.showSuccessToast()
                                props.setValue(e.value);
                                props.component.refresh()
                            } else {
                                props.setValue(e.previousValue);
                                props.component.refresh()
                                return alert(resp[0].message, 'Warning!')
                            }
                        } catch (e) {
                            LoaderService.setData(false)
                            return alert(response.data, 'Error!')
                        }

                    })
                    .catch(err => {
                        LoaderService.setData(false)
                        console.log(err)
                        return alert(err, 'Error!')
                    })
            },
            [props],
        );

        return (<TextArea value={props.value} onValueChanged={onValueChanged}/>)
    }

    const editingStart = e => {
        if (e.column.dataField === "Remarks") {
            if (!isDoubleClick) {
                e.component.selectRows(e.key)
                e.cancel = true;
            }
            if (isDoubleClick) {
                setIsDoubleClick(false);
            }
        }
    }

    const cellDoubleClick = e => {
        if (e.column.dataField === "Remarks") {
            setIsDoubleClick(true)
            e.component.editCell(e.rowIndex, e.columnIndex)
        }
    }

    function settingsForBankLoanTransactions(data) {
        store.set("SettingsForBankLoanTransactions", JSON.stringify(data))
        navigate("/loans/bank-loan-transactions")
    }

    return (
        <>
            <div
                className="search-actions-header d-flex flex-wrap flex-lg-nowrap justify-content-between align-items-center px-3 pt-3 p-lg-3 bg-white border-bottom">
                <div className="d-sm-flex justify-content-between align-items-center flex-fill mb-3 mb-lg-0">
                    <h2 className="fs-5 fw-medium mb-3 mb-sm-0 flex-shrink-0 me-4">Bank Loans</h2>
                </div>
            </div>
            <div className="main-wrapper p-3">
                <Card className="p-3 border-0 dashboard-border">
                    <div
                        className="d-flex flex-wrap flex-xl-nowrap justify-content-between align-items-center mb-0 mb-md-4">

                        <div className="d-flex align-items-center justify-content-sm-end flex-fill me-lg-1">
                            <Button variant="outline-primary" className="flex-shrink-0 me-3"
                                    onClick={addNewBankLoan}>
                                Add
                            </Button>
                            <Button variant="outline-primary" className="flex-shrink-0 me-3"
                                    onClick={clearFilter}>
                                Clear Filter
                            </Button>
                            <InputGroup className="me-3 search-input">
                                <TextBox placeholder="Search Lookup Values..."
                                         ref={searchBoxRef}
                                         mode="search"
                                         inputAttr={{class: "form-control"}}
                                         elementAttr={{class: "search-input input-group"}}
                                         width="100%"
                                         onValueChanged={searchByText}
                                ></TextBox>
                            </InputGroup>
                        </div>
                    </div>
                    <div className="tab-content pt-1">
                        <DataGrid
                            ref={gridInstance}
                            dataSource={gridData}
                            keyExpr={"externalId"}
                            height={height}
                            onCellPrepared={cellPrepared}
                            onContextMenuPreparing={contextMenuPreparing}
                            onCellDblClick={cellDoubleClick}
                            onEditingStart={editingStart}
                            {...gridCustomization}
                            onExporting={onExcelExporting}
                        >
                            {gridColumns.map(col => {
                                return cl.generateReactColumnsFromJson(col)
                            })}
                            <Template name="myTemplate" render={MoreOptionsButton}/>
                            <Template name="contextMenuTemplate" render={ContextMenuTemplate}/>
                            <Template name="remarksTemplate" render={RemarksColumn}/>
                        </DataGrid>
                    </div>
                </Card>
                <ManageBankLoanDetails
                    show={manageBankLoanDetails.show}
                    externalId={manageBankLoanDetails.externalId}
                    readOnly={manageBankLoanDetails.readOnly}
                    handleClose={() => {
                        setManageBankLoanDetails({
                            ...manageBankLoanDetails,
                            show: false,
                            externalId: ''
                        })
                    }}
                    isUpdated={() => {
                        getData(true)
                    }}
                />

            </div>
        </>
    );
}

export default Loans;